import { Stat, Stats } from '../ProfileMenu.styles';

const ProfileMenuStats = ({ tokenCount, planExpiry, tokensLabel, planValidUntilLabel }) => (
	<Stats>
		<Stat>
			<span>{tokensLabel}</span>
			<strong>{tokenCount}</strong>
		</Stat>
		<Stat>
			<span>{planValidUntilLabel}</span>
			<strong>{planExpiry?.slice(0, 10) ?? '—'}</strong>
		</Stat>
	</Stats>
);

export default ProfileMenuStats;
